export default __webpack_public_path__ + "static/media/material-ui-logo.741a52f5.svg";